import axios from "./configs/axiosConfig";

export const userSignup = async (userData) => {
  const url = `/signup`;
  return await axios.post(url, userData);
};
export const userPasswordChange = async (pwdData) => {
  const url = `/changepassword`;
  return await axios.post(url, pwdData);
};

// userPasswordReset (POST /resetpassword) is gone: forgot-password is Cognito-native now
// (VerifyUser -> forgotPassword, ResetPassword -> confirmPassword) and jbwuserresetpassword
// refuses every caller.

export const resendExpiredUserInvite = async (email) => {
  const url = `/resetpasswordexpireduser`;
  return await axios.post(url, { email });
};

export const getEmailLog = async (email, emailType) => {
  const params = new URLSearchParams({ email });
  if (emailType) params.set("emailType", emailType);
  return await axios.get(`/emaillog?${params}`);
};
